<div class="virtual-background-modal-container">
  <div class="header">
    <app-pencil-button
      theme="icon"
      [icon]="(isMobile$ | async) ? 'arrow_back' : 'close'"
      [iconConfig]="{ type: 'material-icon', width: 24, height: 24 }"
      [class.btn-back-arrow]="isMobile$ | async"
      [class.close-icn]="(isMobile$ | async) === false"
      (clickEvent)="close()"
    >
    </app-pencil-button>
    {{ 'Virtual Background' | translate }}
  </div>
  <div class="body">
    <div class="preview-section">
      <span class="loading-text" *ngIf="(videoStream$ | async) === null">{{
        'Camera is off. Effects will apply upon activation.' | translate
      }}</span>
      <span class="loading-text" *ngIf="(videoStream$ | async) && !isVideoPlaying">{{
        'Applying virtual background effects...' | translate
      }}</span>
      <video
        [hidden]="!isVideoPlaying || (videoStream$ | async) === null"
        #virtualBackgroundPreview
        id="virtual-background-preview"
        muted
        playsinline
        autoplay="autoplay"
      ></video>
    </div>
    <div class="vector-border"></div>
    <div class="backgrounds-section">
      <span class="sub-title">{{
        'Choose your preferred background' | translate | uppercase
      }}</span>
      <div class="virtual-backgrounds-widgets-container">
        <div class="virtual-background-widget">
          <button
            class="widget-frame"
            [class.active]="
              virtualBackgroundServiceBase.virtualBackgroundType === virtualBackgroundType.NONE
            "
            (click)="removeBackground()"
            appPreventEnter
          >
            <mat-icon class="no-effect-icon">block</mat-icon>
            <mat-icon class="check-icon">check</mat-icon>
          </button>
          <span class="widget-title">{{ 'No effect' | translate }}</span>
        </div>
        <div class="virtual-background-widget">
          <button
            class="widget-frame"
            [class.active]="
              virtualBackgroundServiceBase.virtualBackgroundType ===
              virtualBackgroundType.BACKGROUND_BLUR
            "
            (click)="blur()"
            appPreventEnter
          >
            <svg-icon
              [icon]="'blur_icon'"
              [width]="'24px'"
              [height]="'20px'"
              [maxWidth]="'fit-content'"
            ></svg-icon>
            <mat-icon class="check-icon">check</mat-icon>
          </button>
          <span class="widget-title">{{ 'Blur' | translate }}</span>
        </div>
      </div>

      <!-- Institution Virtual Backgrounds Section -->
      <ng-container *ngFor="let vbImageCategory of virtualBackgroundServiceBase.vbImagesCategories">
        <span class="sub-title category-title" *ngIf="vbImageCategory.images.length > 0">{{
          vbImageCategory.title | translate | uppercase
        }}</span>
        <div class="virtual-backgrounds-widgets-container">
          <ng-container *ngFor="let vbImage of vbImageCategory.images; index as i">
            <div class="virtual-background-widget">
              <button
                class="widget-frame"
                [style.background-image]="'url(' + (vbImage.thumbnail || vbImage.src) + ')'"
                (click)="vbImage.onClick({ image: vbImage, category: vbImageCategory })"
                [class.active]="
                  virtualBackgroundServiceBase.virtualBackgroundType ===
                    virtualBackgroundType.BACKGROUND_IMAGE && vbImage.active
                "
                appPreventEnter
              >
                <mat-icon class="check-icon">check</mat-icon>
              </button>
              <span class="widget-title" *ngIf="vbImageCategory.hasImageLabels">{{
                vbImage.title ? (vbImage.title | translate) : ''
              }}</span>
              <button
                *ngIf="vbImageCategory.userUploaded"
                class="delete-button"
                (click)="deleteImage(vbImageCategory, vbImage.src)"
              >
                <mat-icon class="delete-icon">delete_outline</mat-icon>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="vbImageCategory.hasUpload">
            <ng-container *ngTemplateOutlet="importWidget"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="footer">
    <div class="noticed-error error" *ngIf="vbError$ | async">
      <span class="material-icons">warning</span>
      <span class="noticed-error-text">
        {{
          'Could not start virtual background. Please refresh the page and try again.' | translate
        }}
        <a (click)="handleLearnMoreClick()">{{ 'Learn more' | translate }}</a>
      </span>
    </div>
    <div
      class="noticed-error"
      *ngIf="
        !(vbError$ | async) &&
        virtualBackgroundServiceBase.virtualBackgroundType !== virtualBackgroundType.NONE
      "
    >
      <span class="material-icons">warning</span>
      <span class="noticed-error-text">
        {{ 'Please note: Enabling this feature may slow down your device. ' | translate }}
        <a (click)="handleLearnMoreClick()">
          {{ 'Learn more' | translate }}
        </a>
      </span>
    </div>
    <button [style.background]="'#2F80ED'" (click)="apply()">
      <mat-icon>check</mat-icon>
      {{ 'Done' | translate }}
    </button>
  </div>
</div>
<ng-template #importWidget>
  <div class="virtual-background-widget">
    <button
      class="widget-frame import-button"
      (click)="virtualBackgroundServiceBase.uploadBackground()"
      appPreventEnter
    >
      <mat-icon class="white-icon">add_circle_outline</mat-icon>
    </button>
    <span class="widget-title">{{ 'Import' | translate }}</span>
  </div>
</ng-template>
